import { forwardRef } from 'react';

import { Group, GroupProps } from '@mantine/core';

import cx from './BadgePill.module.scss';

export const BadgePill = forwardRef<HTMLDivElement, GroupProps>(({ className, ...props }, ref) => (
    <Group
        ref={ref}
        align="center"
        gap={6}
        wrap="nowrap"
        className={[cx.pill, className].filter(Boolean).join(' ')}
        {...props}
    />
));

BadgePill.displayName = 'BadgePill';
